import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getLiquidityPool } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { LUCKIFY_CONTRACT_ADDRESS } from "../../utils/Enviroment";
import Web3 from "web3";
const PendingBet = () => {
  const { account } = useWeb3React();
  const web4 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );

  const web3 = useWeb3();
  const contractAddress = LUCKIFY_CONTRACT_ADDRESS;
  const PendingBetHook = useCallback(
    async (saccount) => {
      const contract = getLiquidityPool(contractAddress, web4);
      if (!contract) {
        console.error("Contract not initialized properly.");
        return;
      }
      try {
        const PendingBet = await contract?.methods
          ?.pendingBets(saccount)
          ?.call();
        return PendingBet;
      } catch (error) {
        console.error("Error fetching balance:", error.message || error);
        throw error;
      }
    },
    [account, web4]
  );
  return { PendingBetHook };
};

export default PendingBet;
